<div id="container" class="flex flex-col gap-3">
  <span class="bg-[#FDF0D5] w-fit rounded-md p-1 text-[var(--lightRed)]">
    <i class='bx bx-book-open'></i>
    Gabarito:
    <span class="text-black" [innerHTML]="safeGabarito"></span> 
  </span>
  <span class="bg-[#FDF0D5] w-fit rounded-md p-1 text-[var(--lightRed)]">
    <i class='bx bx-paperclip'></i> 
    Anexos:
    <span class="text-black">{{ related }}</span> 
  </span>
</div>
